<template>
    <div class="account-page">
        <div class="main-wrapper">
            <div class="account-content">
                <div class="login-wrapper">
                    <div class="login-content">
                        <div class="login-userset">
                            <div class="login-logo logo-normal">
                                <img src="../../../assets/img/logo.png" alt="img" />
                            </div>
                            <router-link to="/index" class="login-logo logo-white">
                                <img src="../../../assets/img/logo-white.png" alt="" />
                            </router-link>
                            <div class="login-userheading">
                                <h3>Sign In</h3>
                                <p class="login-subtitle">Please login to your account</p>
                                <div v-if="selectedLocation" class="selected-location-badge">
                                    <i class="fas fa-check-circle"></i>
                                    <span>{{ selectedLocation }}</span>
                                </div>
                            </div>

                            <Form
                                class="login"
                                @submit="onSubmit"
                                :validation-schema="schema"
                                v-slot="{ errors }"
                            >
                                <div class="form-login">
                                    <label>Email</label>
                                    <div class="form-addons">
                                        <Field
                                            name="email"
                                            type="text"
                                            v-model="email"
                                            class="form-control"
                                            :class="{ 'is-invalid': errors.email || apiErrors.email }"
                                        />
                                        <div class="invalid-feedback">{{ errors.email || apiErrors.email }}</div>
                                        <img src="../../../assets/img/icons/mail.svg" alt="img" />
                                    </div>
                                </div>
                                <div class="form-login">
                                    <label>Password</label>
                                    <div class="pass-group">
                                        <Field
                                            name="password"
                                            :type="passwordType"
                                            v-model="password"
                                            class="form-control pass-input"
                                            :class="{ 'is-invalid': errors.password || apiErrors.password }"
                                        />
                                        <span
                                            @click="toggleShow"
                                            class="fas toggle-password"
                                            :class="{
                                                'fa-eye': showPassword,
                                                'fa-eye-slash': !showPassword,
                                            }"
                                        ></span>
                                        <div class="invalid-feedback">{{ errors.password || apiErrors.password }}</div>
                                    </div>
                                </div>
                                
                                <div v-if="apiErrors.general" class="alert alert-danger mb-3">
                                    {{ apiErrors.general }}
                                </div>
<!-- 
                                <div class="form-login">
                                    <div class="alreadyuser">
                                        <h4>
                                            <router-link to="forgetpassword" class="hover-a"
                                                >Forgot Password?</router-link
                                            >
                                        </h4>
                                    </div>
                                </div> -->
                                <div class="form-login">
                                    <button class="btn btn-login" type="submit" :disabled="isLoading">
                                        {{ isLoading ? 'Loading...' : 'Sign In' }}
                                    </button>
                                </div>
                            </Form>

                            <!-- <div class="signinform text-center">
                                <h4>
                                    Don’t have an account?
                                    <router-link to="signup" class="hover-a">Sign Up</router-link>
                                </h4>
                            </div>
                            <div class="form-setlogin">
                                <h4>Or sign up with</h4>
                            </div>
                            <div class="form-sociallink">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0);">
                                            <img
                                                src="../../../assets/img/icons/google.png"
                                                class="me-2"
                                                alt="google"
                                            />
                                            Sign Up using Google
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);">
                                            <img
                                                src="../../../assets/img/icons/facebook.png"
                                                class="me-2"
                                                alt="google"
                                            />
                                            Sign Up using Facebook
                                        </a>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                    <div class="login-img">
                        <img src="../../../assets/img/login.jpg" alt="img" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>

<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { mapActions } from 'vuex';

export default {
    components: {
        Form,
        Field,
    },
    data() {
        return {
            email: this.$route.query.email || '', 
            password: "", 

            showPassword: false,
            isLoading: false,

            
            apiErrors: {
                email: null,
                password: null,
                general: null,
            },

            
            schema: Yup.object().shape({
                email: Yup.string().required("Email is required").email("Email is invalid"),
                password: Yup.string()
                    .min(6, "Password must be at least 6 characters")
                    .required("Password is required"),
            }),
        };
    },
    computed: {
        passwordType() {
            return this.showPassword ? "text" : "password";
        },
        selectedLocation() {
            return this.$store.getters.getSelectedLocation;
        },
    },
    methods: {
        
        ...mapActions(['login']),

        toggleShow() {
            this.showPassword = !this.showPassword;
        },

        async onSubmit(values) {
            
            this.apiErrors = { email: null, password: null, general: null };
            this.isLoading = true;

            try {
                
                await this.login({ 
                    email: values.email, 
                    password: values.password 
                });

                
                this.$router.push({ name: 'index' });

            } catch (err) {
                
                const responseData = err.response?.data.detail;
                const status = responseData?.status;
                const message = responseData?.message;
                console.log('Data:',responseData,'status',status,'message',message,'err',err)

                if (status === 'PASSWORD_CHANGE_REQUIRED') {
                    
                    this.apiErrors.general = message || 'You must change your password before logging in.';
                    
                    
                    this.$router.push({ 
                        name: 'change-password', 
                        query: { email: values.email, force: true } 
                    });

                } else if (status === 'FAILED') {
                    
                    this.apiErrors.general = message || 'Invalid email or password.';
                } else {
                    
                    this.apiErrors.general = 'An unexpected error occurred. Check your network connection or try again later.';
                }

            } finally {
                this.isLoading = false;
            }
        },
    },
    
    created() {
        if (this.$store.getters.isAuthenticated) {
            this.$router.push({ name: 'index' });
        }
    }
};
</script>

<style scoped>
/*
    Since this is a full component template, 
    it relies on external CSS files (like 'fas', 'pass-group', 'btn-login') 
    from your template framework. The custom scoped style from the previous 
    response is omitted to rely on your existing template styles, 
    but essential structure remains.
*/
.pass-group {
    position: relative;
}

.toggle-password {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;
}

/* Signin Page Styling */
.login-userheading {
    margin-bottom: 30px;
    text-align: center;
}

.login-userheading h3 {
    font-size: 32px;
    font-weight: 700;
    color: #222;
    margin-bottom: 8px;
}

.login-subtitle {
    font-size: 15px;
    color: #666;
    margin: 0 0 18px 0;
    font-weight: 400;
    letter-spacing: 0.3px;
}

.selected-location-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #ff9f43 0%, #e67e22 100%);
    color: white;
    padding: 10px 18px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0 4px 15px rgba(255, 159, 67, 0.35);
    transition: all 0.3s ease;
}

.selected-location-badge:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 159, 67, 0.4);
}

.selected-location-badge i {
    font-size: 13px;
}

/* Ensure Vee-validate invalid class styling is applied */
.is-invalid {
    border-color: #dc3545 !important;
}

.invalid-feedback {
    display: block; /* Force display for custom placement */
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
}
</style>